<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="分摊门店" prop="storeKeyIds">
				<el-select v-model="editForm.storeKeyIds" placeholder="请选择分摊门店（可多选）" clearable size="small" multiple class="input_200px" filterable :disabled="editForm.isConfirm == true">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="报销日期" prop="costDate">
				<el-date-picker v-model="editForm.costDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择报销日期" size="small" class="input_200px" :disabled="editForm.isConfirm == true" />
			</el-form-item>
			<el-form-item label="报销内容" prop="content">
				<el-input v-model="editForm.content" type="textarea" :rows="3" class="input_200px" size="small" :disabled="editForm.isConfirm == true" />
			</el-form-item>
			<el-form-item label="报销金额" prop="money">
				<el-input-number v-model.number="editForm.money" type="number" class="input_200px" size="small" :precision="2" :step="0.01" :disabled="editForm.isConfirm == true" />
			</el-form-item>
			<el-form-item label="支付方式" prop="payUserType">
				<el-radio-group v-model="editForm.payUserType" size="small" class="input_200px" :disabled="editForm.isConfirm == true">
					<el-radio :label="1">个人</el-radio>
					<el-radio :label="2">公司</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="支付凭证">
				<ImageListUpload
					v-model="fileList"
					class="input_200px"
					:file-limit="5"
					FileTypeId="reimbursement"
					:file-size="5"
					:disabled="editForm.isConfirm == true"
					:is-edit="editForm.isConfirm == false"
					@input="handleInput"
				/>
			</el-form-item>
			<el-form-item label="备注" prop="remark">
				<el-input v-model="editForm.remark" type="textarea" :rows="3" class="input_200px" :disabled="editForm.isConfirm == true" />
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button v-if="editForm.isConfirm == false" size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { SaveReimbursement, GetReimbursementDetail } from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import ImageListUpload from "@/components/ImageListUpload.vue";
export default {
	watch: {
		editFormVisible(visible) {
			if (!visible) return;
			this.GetOrgInfoListByConfig();
		}
	},
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
		editForm: {
			keyId: "",
			filePath: "",
			content: "",
			money: 0,
			payUserType: 1,
			remark: "",
			isConfirm: false,
			costDate: "",
			storeKeyIds: []
		},
		allocationStoreNames: [],
		storeList: [],
		// rules 表单验证
		rules: {
			storeKeyIds: [
				{
					required: true,
					type: "array",
					message: "请选择分摊门店",
					trigger: "change"
				},
				{
					validator: (rule, value, callback) => {
						// 至少选择一个分摊门店
						if (!value || value.length === 0) {
							callback(new Error("请至少选择一个分摊门店"));
						} else {
							callback();
						}
					},
					trigger: "change"
				}
			],
				content: [
					{
						required: true,
						message: "请输入报销内容",
						trigger: "blur"
					}
				],
				money: [
					{
						required: true,
						message: "请输入报销金额",
						trigger: "blur"
					},
					// 报销金额必须是数字
					{
						type: "number",
						message: "报销金额必须是数字",
						trigger: "blur"
					},
					// 报销金额必须大于0
					{
						validator: (rule, value, callback) => {
							if (value == 0) {
								callback(new Error("报销金额不能等于0"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				],
				payUserType: [
					{
						required: true,
						message: "请选择支付方式",
						trigger: "blur"
					}
				],
				costDate: [
					{
						required: true,
						message: "请选择报销日期",
						trigger: "blur"
					}
				]
			},
			fileList: []
		};
	},
	methods: {
		//显示编辑界面
		editShow(row) {
			this.fileList = [];
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetReimbursementDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							var detail = res.data;
							// 始终用分摊明细填充门店多选（单门店时明细只有 1 条）
							if (detail.allocations && detail.allocations.length > 0) {
								detail.storeKeyIds = detail.allocations.map(function (a) { return a.storeKeyId; });
							} else if (detail.storeKeyId) {
								detail.storeKeyIds = [detail.storeKeyId];
							}
							this.editForm = detail;
							if (detail.filePath != null && detail.filePath != "") {
								this.fileList = JSON.parse(detail.filePath);
							}
							this.editFormVisible = true;
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
						this.$message.error("获取报销费用详情失败，请稍后再试！");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.allocationStoreNames = [];
				this.editFormVisible = true;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			if (this.editForm.filePath == "") {
				this.$message.error("请上传支付凭证！");
				return;
			}
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveReimbursement(this.editForm)
						.then((res) => {
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "报销费用保存成功！"
								});
								this.editFormVisible = false;
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("报销费用保存失败，请稍后再试！");
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		handleInput(file) {
			if (file.length > 0) {
				this.editForm.filePath = JSON.stringify(file);
			} else {
				this.editForm.filePath = "";
			}
		}
	},
	created() {},
	mounted() {},
	components: {
		ImageListUpload
	}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
.width_100 {
	width: 100% !important;
}
</style>
